module.exports = __webpack_public_path__ + "static/media/ontario-icon-new-window.a1c795ef.svg";